import { MapPin, Phone, Clock } from 'lucide-react';

const WA_NUMBER = '19999787030';
const WA_LINK = `https://wa.me/${WA_NUMBER}`;

function WhatsAppIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-border mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Coluna 1 — Salão Lima */}
          <div className="flex flex-col gap-3">
            <span className="font-logo text-2xl text-primary">SALÃO LIMA</span>
            <p className="text-sm text-text-muted leading-relaxed">
              Barbearia premium em Indaiatuba&nbsp;–&nbsp;SP. Agendamento online rápido e fácil.
            </p>
            <div className="flex items-center gap-3 mt-1">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp do Salão Lima"
                className="text-text-muted hover:text-success transition-colors duration-normal"
              >
                <WhatsAppIcon size={20} />
              </a>
              <a
                href="https://instagram.com/salaolimabarber"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram do Salão Lima"
                className="text-text-muted hover:text-primary transition-colors duration-normal"
              >
                {/* Instagram icon SVG */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Coluna 2 — Contato */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wider">Contato</h3>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-text-secondary hover:text-primary transition-colors duration-normal"
                >
                  <WhatsAppIcon size={15} />
                  (19) 99978-7030
                </a>
              </li>
              <li>
                <a
                  href="tel:+5519999787030"
                  className="flex items-center gap-2 text-sm text-text-secondary hover:text-primary transition-colors duration-normal"
                >
                  <Phone size={15} aria-hidden="true" />
                  (19) 99978-7030
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=Av.+Ário+Barnabé,+160,+Jardim+Morada+do+Sol,+Indaiatuba+SP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-sm text-text-secondary hover:text-primary transition-colors duration-normal"
                >
                  <MapPin size={15} className="shrink-0 mt-0.5" aria-hidden="true" />
                  Av. Ário Barnabé, 160 – Jardim Morada do Sol, Indaiatuba – SP
                </a>
              </li>
            </ul>
          </div>

          {/* Coluna 3 — Horários */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wider">Horários</h3>
            <ul className="flex flex-col gap-2 text-sm text-text-secondary">
              <li className="flex items-center gap-2">
                <Clock size={15} className="shrink-0 text-text-muted" aria-hidden="true" />
                <span>Seg – Sex: <span className="text-text-primary font-medium">08:00 – 20:00</span></span>
              </li>
              <li className="flex items-center gap-2">
                <Clock size={15} className="shrink-0 text-text-muted" aria-hidden="true" />
                <span>Sábado: <span className="text-text-primary font-medium">07:50 – 18:00</span></span>
              </li>
              <li className="flex items-center gap-2 text-text-muted">
                <Clock size={15} className="shrink-0" aria-hidden="true" />
                <span>Domingo: fechado</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Barra inferior */}
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-text-muted">
            &copy; {year} Salão Lima. Todos os direitos reservados.
          </p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-text-muted hover:text-primary transition-colors duration-normal"
          >
            Fale conosco
          </a>
        </div>
      </div>
    </footer>
  );
}
